export default () => {
  return (
    <section className="py-28 relative bg-orange-600">
      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
        <div className="max-w-xl md:mx-auto">
          <p className="text-white text-3xl font-extrabold sm:text-4xl">
            Ready to post your first request?
          </p>
          <p className="text-blue-100 mt-3">
            Find matches for your next job request completely FREE with our
            platform.
          </p>
        </div>
        <div className="mt-4">
          {/* <a
            href="/"
            className="text-lg inline-block py-4 px-5 text-gray-800 font-medium bg-white duration-150 hover:bg-gray-100 active:bg-gray-200 rounded-full"
          >
            Create An Account
          </a> */}
          <a
            href="#appointment"
            className="mt-3 md:mt-0 text-lg inline-block py-4 md:ml-2 px-5 text-gray-100 font-medium bg-sky-900 duration-150 hover:bg-sky-700 active:bg-sky-700 rounded-full"
          >
            Find handyman near me
          </a>
        </div>
      </div>
    </section>
  );
};
